export default __webpack_public_path__ + "static/media/3.88fa5077.svg";